import { hasRoleClaim, type JwtClaims } from "@cms/portal-lib/claims";

export * from "@cms/portal-lib/claims";

export function hasTenantRoleClaim(claims: JwtClaims): boolean {
  return hasRoleClaim(claims, "tenant");
}
